import {createPrimitiveAtom} from '@reatom/core/primitives'

type WarehouseIdKey = string

export const registerPageLocationsAtom = createPrimitiveAtom<Record<WarehouseIdKey, Array<string>>>({})
